<template>
  <div class="text-center div_btn_inline">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="#b5a36a"
            icon
            v-bind="attrs"
            v-on="on"
            @click="dialog = true"
          >
            <v-icon>
              mdi-share-variant
            </v-icon>
          </v-btn>
      </template>
        <span>Compartir liga de encuesta</span>
    </v-tooltip>

    <v-dialog
      v-model="dialog"
      width="1000"
      max-width="1000"
      scrollable
    >
      <v-card>
        <v-card-title class="text-h5 blue darken-4 lighten-2">
          <v-row no-gutters>
            <v-col cols="12">
              <div class="h5" style="color:white!important;">Compartir</div>
            </v-col>
            <v-col cols="12">
              <div class="subtitle-1" style="color:white!important;">{{objEncuesta.nombreEncuesta}}</div>          
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text >
          <v-row class="mx-2 mt-2">
            <v-col cols="12">
              <v-tooltip
                v-model="showTooltip"
                bottom
                color="success"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="link"                
                    label="Link de encuesta"
                    readonly
                    outlined
                    append-icon="mdi-content-copy"
                    @click:append="copyText"
                    hide-details
                  ></v-text-field>
                </template>
                <span><v-icon color="white">mdi-check</v-icon> Link copiado al portapepeles</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-center" md="4" offset-md="4">
              <vue-qr 
                :logoSrc="require('@/assets/UGTO.png')" 
                :correctLevel='2' 
                :text="link" 
                :size="300" 
                :autoColor='true'
                :logoScale='0.3'
                :logoCornerRadius='10'
              ></vue-qr>
            </v-col>
          </v-row>
        </v-card-text>



        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Cerrar</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>

      <v-snackbar
        key="snackbar_dialogcompartir2"
        v-model="snackbar2"
        :bottom="true"
        :multi-line="true"
        :color="snackbarColor2"
      >
        <div class="v-menu__content--active" style="display:none; z-index:1000;"></div>
        {{ snackbarTexto2 }}
        <v-btn 
            dark 
            text 
            @click="snackbar2 = false">
            Cerrar
        </v-btn>
      </v-snackbar>
    </v-dialog>


    <v-snackbar
      key="snackbar_dialogcompartir"
      v-model="snackbar"
      :bottom="true"
      :multi-line="true"
      :color="snackbarColor"
    >
      {{ snackbarTexto }}
      <v-btn dark text @click="snackbar = false">
        Cerrar
      </v-btn>
    </v-snackbar>
    
  </div>
</template>

<script>
import VueQr from'vue-qr'
import {baseUri} from "@/config";

export default {
  name: "DialogCompartir",
  components: {
  },
  props: {
    objEncuesta: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      dialogConfirmar: false,
      loading: true,
      showTooltip: false, 
      snackbar: false,
      snackbarTexto: "",
      snackbarColor: "",

      snackbar2: false,
      snackbarTexto2: "",
      snackbarColor2: "",
    };

  },
  computed: {
    link: function () {

      var prevURL = baseUri;
      
      prevURL += this.objEncuesta.conAutenticacion == true ? "/Encuesta/" : "/EncuestaPublica/";

      return prevURL + this.objEncuesta.idEncuesta + '/' + this.objEncuesta.tokenEncuesta
    }
  },
  watch:{
    dialog: {
      handler(newValue, oldValue) {
        if(newValue == true){
          this.flagReloadTable++;
        }
      },
    },
  },
  beforeMount(){
  },
  mounted() {
  },
  methods: {
    copyText() {
      this.showTooltip = true;
      navigator.clipboard.writeText(this.link);
        setTimeout(() => {
          this.showTooltip = false;
         }, 3000);
    }
  },  
};
</script>